export var FrequentlyAskedQuestionsFilterOption;
(function (FrequentlyAskedQuestionsFilterOption) {
    FrequentlyAskedQuestionsFilterOption["ProductCode"] = "faqsFilter.ProductCode";
    FrequentlyAskedQuestionsFilterOption["ProductSku"] = "faqsFilter.ProductSku";
    FrequentlyAskedQuestionsFilterOption["Top"] = "faqsFilter.Top";
})(FrequentlyAskedQuestionsFilterOption || (FrequentlyAskedQuestionsFilterOption = {}));
